import React from 'react';
import moment from 'moment';
import config from 'coeus.config';
import * as Icon from '@material-ui/icons';
import { Grid } from '@material-ui/core';

const Footer = () => {
    let footerText = config?.feature?.footer?.config?.footerText;
    let showFooter = config?.feature?.footer
        ? config?.feature?.footer?.enabled
        : true;

    footerText = footerText || 'Catalyst-IT Solutions';
    const links = config?.feature?.footer?.config?.links;

    const link = ({ name, href }) => {
        return (
            <a
                key={name}
                className="c-footer__link"
                href={href}
                target={'_blank'}
                rel="noreferrer"
            >
                {name}
            </a>
        );
    };

    return (
        <>
            {showFooter && (
                <div className="u-pr-small u-pl-small">
                    <div className="row">
                        <div className="col-12">
                            <footer className="c-footer">
                                <Grid container direction={'row'}>
                                    <span
                                        className={'c-footer__link'}
                                        style={{
                                            display: 'flex',
                                            direction: 'row',
                                            gap: 5,
                                        }}
                                    >
                                        {footerText}{' '}
                                        <Icon.Copyright fontSize={'small'} />{' '}
                                        {moment().format('YYYY')}
                                    </span>
                                    {links &&
                                        links.map((item) => {
                                            return link(item);
                                        })}
                                </Grid>
                            </footer>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
